import { BetslipPanel } from '@/betslip';
import { cn } from '@/lib/cn';
import { RewardsNotificationBanner } from '@/ui/rewards';

export interface SportsRightRailProps {
  className?: string;
}

/**
 * Desktop betslip column for sports pages (xl+ via AppShell aside).
 * Fills the aside; selections scroll and the stake / place-bet footer stays pinned.
 */
export function SportsRightRail({ className }: SportsRightRailProps) {
  return (
    <div className={cn('flex h-full min-h-0 w-full flex-col gap-2', className)}>
      <RewardsNotificationBanner desktopOnly className="shrink-0" />
      <BetslipPanel className="h-full min-h-0 flex-1" />
    </div>
  );
}
